import { Transition } from '@uirouter/core';
import { AccessDeniedService } from '../../services/core.access-denied.service';
import { UserService } from '../../services/core.user.service';
import { SiteHelpComponent } from './site-help.component';
import { SiteHelpService } from './site-help.service';
import { SiteHelpPageComponent } from './site-help-page/site-help-page.component';
import { SiteHelpSearchComponent } from './site-help-search/site-help-search.component';

/**
 * Search needs a login. A logged-out user is sent to login with the search URL (query
 * included) as the return URL, so they come back to the search they asked for.
 */
export function siteHelpSearchGuard(userService: UserService, accessDeniedService: AccessDeniedService, transition: Transition): any {
    if (userService.session.hasUser()) {
        return true;
    }
    return accessDeniedService.goLogin(transition);
}

/**
 * Site manual (#47397). Reading is anonymous (the `home` resolves leave a
 * "nobody" user in place and do not redirect); search requires a login.
 *
 * `home.site-help` is the shared layout (heading, breadcrumbs, topics tree);
 * its children render in the content panel. `/site-help` itself redirects to
 * the default page. The search state is declared
 * before the page state so `site-help/search` is never taken as a page name.
 * The `custom/**` namespace is reserved for later and not routed.
 */
export const SITE_HELP_STATES: any[] = [
    {
        name: 'home.site-help',
        url: 'site-help',
        abstract: true,
        views: {
            'contentarea@home': {
                component: SiteHelpComponent
            }
        }
    },
    {
        name: 'home.site-help.home',
        url: '',
        redirectTo: { state: 'home.site-help.page', params: { page: SiteHelpService.DEFAULT_PAGE } }
    },
    {
        name: 'home.site-help.search',
        url: '/search?q',
        params: {
            q: { value: '', squash: true, raw: true, dynamic: true }
        },
        resolve: [
            {
                token: 'siteHelpLogin',
                deps: [UserService, AccessDeniedService, Transition],
                resolveFn: siteHelpSearchGuard
            }
        ],
        component: SiteHelpSearchComponent
    },
    {
        name: 'home.site-help.page',
        url: '/:page',
        component: SiteHelpPageComponent
    }
];
